export default __webpack_public_path__ + "static/media/icon-recorded.b59446d2.svg";